import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-select-search',
    templateUrl: './select-search.component.html',
    styleUrls: ['./select-search.component.scss'],
    standalone: false
})
export class SelectSearchComponent {

  @Input() label: string;
  @Input() model: any;
  @Input() list: any[];
  @Input() isRequired: boolean = false;
  @Input() isMultiple: boolean = false;
  @Input() isDisabled: boolean = false;
  @Output() modelChanged: EventEmitter<any>;

  constructor() {
    this.modelChanged = new EventEmitter<any>();
  }
  searchText = '';

  onModelChange() {
    this.modelChanged.emit(this.model);
  }
}
